import React, { PropsWithChildren } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { useSignUpDesign } from '@/store/useSignUpDesign';
import { routesApp } from '@/constans/routes';

interface Props {}

export const PrivateRoutes: React.FC<PropsWithChildren<Props>> = () => {
    const location = useLocation();

    const emptyFields = useAuth((state) => state.emptyFields);

    const profileWasRemovedError = useAuth((state) => state.profileWasRemovedError);
    
    const signUpDesign = useSignUpDesign((state) => state.design)

    if (profileWasRemovedError) {
        return (
            <Navigate
                replace
                to={routesApp.home}
                state={{ from: location }} />
        );
    }
    
    if (emptyFields()) {
        return (
            <Navigate
                replace
                to={signUpDesign === 'new' ? routesApp.registrationV2 : signUpDesign === 'new_photo_last' ? routesApp.registrationV3 : signUpDesign === 'new_skip_steps' ? routesApp.registrationV4 : routesApp.registration}
                state={{ from: location }} />
        );
    }

    return <Outlet />;
};
